import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SimpleButton from '@components/SimpleButton';
import CartPrice from '@cart/components/CartPrice';
import DonationWarning from '@cart/containers/DonationWarning';
import CartList from '@cart/containers/CartList';
import Card from '@components/Card';
import CartRow from '../CartRow';
import Footer from '../Footer';
import Detail from '../Detail';
import {
  Title,
  HeaderContainer,
  ContinueButton,
  EmptyCart,
  EditAction,
} from './components';
import messages from './messages';

function DesktopCart({
  subHeader,
  cartItems,
  onItemChecked,
  onItemClicked,
  isUserLogged,
  cartSubtotal,
  cartDiscounts,
  labelNeedToAdd,
  trackCheckoutClicked,
  trackModalOpened,
  trackModalClosed,
  needsToAdd,
  onConfirmProductsDeletion,
  areOnlyDonationsItemsInCart,
  itemsToremove,
  isUpdatingLines,
  cartId,
  shopId,
  searchedLocation,
  countryShortName,
  isNewUser,
  showNativeModal,
  validateProcucts,
}) {
  const hasItems = !!cartItems?.length;

  const [isEditing, setIsEditing] = useState(false);

  return (
    <Card direction="column">
      {!hasItems && (
        <>
          <Title>
            <FormattedMessage {...messages.title} />
          </Title>
          <EmptyCart />
        </>
      )}
      {hasItems && (
        <>
          <Detail>
            <HeaderContainer border>
              <Title>
                <FormattedMessage {...messages.title} />
              </Title>
              <EditAction onClick={() => setIsEditing(!isEditing)}>
                {isEditing ? (
                  <FormattedMessage {...messages.accept} />
                ) : (
                  <FormattedMessage {...messages.edit} />
                )}
              </EditAction>
            </HeaderContainer>

            {subHeader}
            <CartList
              items={cartItems}
              isEditing={isEditing}
              itemsSelected={itemsToremove}
              onItemChecked={onItemChecked}
              onItemClicked={onItemClicked}
            />
            {isUserLogged && (
              <CartPrice subtotal={cartSubtotal} discounts={cartDiscounts} />
            )}
          </Detail>
          <DonationWarning />
          {!!needsToAdd && (
            <CartRow>
              <SimpleButton
                elementId="cart__continue__action"
                label={labelNeedToAdd}
              />
            </CartRow>
          )}

          <ContinueButton>
            <Footer
              trackCheckoutClicked={trackCheckoutClicked}
              trackModalOpened={trackModalOpened}
              trackModalClosed={trackModalClosed}
              editMode={{
                on: !!itemsToremove.length,
                itemsToRemove: itemsToremove,
              }}
              needsToAdd={needsToAdd}
              onConfirmProductsDeletion={onConfirmProductsDeletion}
              areOnlyDonationsItemsInCart={areOnlyDonationsItemsInCart}
              isUpdatingLines={isUpdatingLines}
              isNewUser={isNewUser}
              cartId={cartId}
              shopId={shopId}
              searchedLocation={searchedLocation}
              countryShortName={countryShortName}
              showNativeModal={showNativeModal}
              validateProcucts={validateProcucts}
            />
          </ContinueButton>
        </>
      )}
    </Card>
  );
}

DesktopCart.propTypes = {
  // data
  cartSubtotal: PropTypes.number.isRequired,
  cartItems: PropTypes.array.isRequired,
  cartDiscounts: PropTypes.array,
  needsToAdd: PropTypes.number.isRequired,
  isUserLogged: PropTypes.bool.isRequired,
  areOnlyDonationsItemsInCart: PropTypes.bool.isRequired,
  businessType: PropTypes.string.isRequired,
  onItemChecked: PropTypes.func.isRequired,
  onItemClicked: PropTypes.func.isRequired,
  labelNeedToAdd: PropTypes.string,
  onConfirmProductsDeletion: PropTypes.func.isRequired,
  itemsToremove: PropTypes.array,
  isUpdatingLines: PropTypes.bool,
  countryShortName: PropTypes.string,
  isNewUser: PropTypes.bool,
  cartId: PropTypes.string,
  shopId: PropTypes.string,
  searchedLocation: PropTypes.object,
  validateProcucts: PropTypes.func,
  showNativeModal: PropTypes.bool,
  // tracking
  trackCheckoutClicked: PropTypes.func.isRequired,
  trackModalOpened: PropTypes.func.isRequired,
  trackModalClosed: PropTypes.func.isRequired,

  // Joker
  subHeader: PropTypes.node,
};

export default DesktopCart;
